import { i18n } from "@lingui/core";
import { t } from "@lingui/core/macro";
import { DateTime } from "luxon";

const formatTime = (time: string) =>
  // eslint-disable-next-line lingui/no-unlocalized-strings
  i18n.date(DateTime.fromFormat(time, "H:mm").toJSDate(), {
    hour: "numeric",
    minute: "numeric",
  });

const formatTradingHoursWithFallback = (
  timeFrom: string | null,
  timeTo: string | null,
): string => {
  const from = formatTime(timeFrom ?? "8:00");
  const to = formatTime(timeTo ?? "16:00");

  return t`${from} - ${to}`;
};

export { formatTradingHoursWithFallback };
